import { Radio, RadioGroup } from "@worthy-npm/clarity";
import {
  Button,
  Divider,
  WorthyThemeProvider,
} from "@worthy-npm/worthy-ui-components";
import React from "react";
import { isMobile } from "../../helpers/ApplicationHelper";
import { getShipBackText } from "../item/shipBack/helpers";
import Popup from "./popup";

const HAL = "shipping_center";
const DIRECT = "direct";

class ShipBackDestinationUpdatePopup extends Popup {
  constructor(props) {
    super(props);

    this.state = {
      destination: this.props.destination || HAL,
    };
    this.intercom = null;
  }

  static initPopup(props = {}) {
    props.stopAnimation ? props.stopAnimation() : null;
    Popup.initPopup.call(this, props);
  }

  componentDidMount() {
    if (isMobile()) {
      this.intercom =
        document.querySelector(".intercom-launcher") ||
        document.querySelector(".intercom-app");
    }
    if (this.intercom) {
      this.intercom.style.display = "none";
    }
  }

  componentWillUnmount() {
    if (this.intercom) {
      this.intercom.style.display = "initial";
    }
  }

  _onPopupClose() {
    if (this.props.stopAnimation) {
      this.props.stopAnimation();
    }
  }

  _hide = () => {
    super._hide();
  };

  onDestinationChange = (destination) => {
    this.setState({ destination });
  };

  onSave = async () => {
    const { destination } = this.state;
    this.props.onSave(destination);
    this._hide();
  };

  title = () => {
    return (
      <>
        {getShipBackText("updateDestinationModalHeader")}
        <br />
        <div className="shipBack--text" style={{ marginTop: 10 }}>
          {getShipBackText("updateDestinationModalSubHeader")}
        </div>
      </>
    );
  };

  footer = () => {
    return (
      <>
        <div className="shipBack--button-group">
          <Button variant="text" onClick={this._hide}>
            {getShipBackText("cancel")}
          </Button>
          <Button onClick={this.onSave}>{getShipBackText("save")}</Button>
        </div>
      </>
    );
  };

  content = () => {
    const { formattedAddress } = this.props;
    const { destination } = this.state;

    return (
      <WorthyThemeProvider>
        <RadioGroup
          name={"shipment-method"}
          initialValue={destination}
          disabled={false}
          onChange={this.onDestinationChange}
        >
          <div className="shipBack-destination-HAL radio-field-wrapper">
            <Radio
              value={HAL}
              label={getShipBackText("destinationHAL")}
              disabled={false}
            />
          </div>
          <div className="shipBack-destination-direct radio-field-wrapper">
            <Radio
              value={DIRECT}
              label={getShipBackText("destinationDirect")}
              disabled={false}
            />
            {/* Shipping address when selected */}
            {destination === DIRECT && (
              <div className="shipBack--desktop-negative-margin-top">
                <div className="d-flex" style={{ marginLeft: 40 }}>
                  <p
                    className="shipBack--text shipBack--text-light"
                    style={{ minWidth: 140 }}
                  >
                    {getShipBackText("updateDestinationShippingAddress")}
                  </p>
                  <p className="shipBack--text">{formattedAddress}</p>
                </div>
                <div className="shipBack--destination-update-explanation">
                  <p className="shipBack--text shipBack--destination-update-address-change">
                    {getShipBackText("updateDestinationUpdateShipTo")}
                  </p>
                </div>
              </div>
            )}
          </div>
        </RadioGroup>
        <Divider borderColor="#F4F4F4" style={{ marginTop: 20 }} />

        {this.footer()}
      </WorthyThemeProvider>
    );
  };
}

ShipBackDestinationUpdatePopup.defaultProps = {
  formattedAddress: "",
  popupClassName: "shipBack shipBack--modal",
  single: true,
  modal: true,
  onPopupClose: function () {
    this._onPopupClose();
  },
};

export default ShipBackDestinationUpdatePopup;
